import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

const ocButtonGroupState = atomFamily({
  key: "ocButtonGroupState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});

export default ocButtonGroupState;
